import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=7c8d5830&"
import script from "./AddProduct.vue?vue&type=script&lang=js&"
export * from "./AddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports